import { FaUsers } from "react-icons/fa";
import React from "react";
import NavBtn from "../NavBtn";

const Customers = (props) => {
  const {
    exactPath = "/dashboard/customers",
    to = "/dashboard/customers",
    partialPath = "/customers",
    label = "Customers",
  } = props;

  return (
    <NavBtn
      label={label}
      exactPath={exactPath}
      partialPath={partialPath}
      to={to}
      Icon={FaUsers}
    />
  );
};

export default Customers;
